/*
 * @Author: liuc
 * @Date: 2022-03-25 14:16:07
 * @Description: 登录，注册先关部分接口
 */
import { fetchPost, fetchGet, fetchPut, fetchDel } from '@/axios';
const LoginManagement = {
    /**
     * @author: liuc
     * @description: 获取当前人信息
     */
    getCurrentUserInfo () {
        return fetchGet('/api/auth/frontmodule/authRegisterUser/current-user-info');
    }

};
export default LoginManagement;



// WEBPACK FOOTER //
// ./src/services/LoginManagement.js